export const returnEnvelopeId = 6974588223550
export const returnEnvelopeVariantId = 39770657226814
